import { Navigate, Outlet } from "react-router-dom";
// import IntegrationLayout from "components/wrappers/IntegrationLayout";
import IntegrationOvertime from "pages/Integration/IntegrationOvertime";
import IntegrationMissions from "pages/Integration/IntegrationMissions";
import IntegrationTransfer from "pages/Integration/IntegrationTransfer";
import IntegrationTransactions from "pages/Integration/IntegrationTransactions";
import SecondarySidebarLayout from "components/wrappers/SecondarySidebarLayout";
import usePermissions from "hooks/usePermission";
import filterByPermissions from "utils/filterByPermissions";
import ProtectedOutlet from "components/wrappers/ProtectedOutlet";
import { PermissionCodename } from "constants/permission";

interface IntegrationRouteType {
  path: string;
  element: JSX.Element;
  permission?: PermissionCodename;
}

export default function IntegrationRoutes() {
  const { hasPermissionTo } = usePermissions();

  const rawChildren: IntegrationRouteType[] = [
    {
      path: "Overtime",
      permission: "view_staff_overtime",
      element: <ProtectedOutlet requiredPermission='view_staff_overtime'> <IntegrationOvertime /> </ProtectedOutlet>,
    },
    {
      path: "Missions",
      permission: "view_requests",
      element: <ProtectedOutlet requiredPermission='view_requests'> <IntegrationMissions /> </ProtectedOutlet>,
    },
    {
      path: "Transfers",
      permission: "view_requests",
      element: <ProtectedOutlet requiredPermission='view_requests'> <IntegrationTransfer /> </ProtectedOutlet>,
    },
    {
      path: "Transactions",
      permission: "view_requests",
      element: <ProtectedOutlet requiredPermission='view_requests'> <IntegrationTransactions /> </ProtectedOutlet>,
    },
  ];

  const filteredList = filterByPermissions(rawChildren, hasPermissionTo);
  const defaultPath = filteredList?.length > 0 ? filteredList?.[0]?.path : "Overtime";

  const children: any[] = [
    {
      path: "",
      element: <Navigate to={defaultPath} />,
    },
    ...rawChildren,
  ];

  return {
    path: "integration",
    element: (
      <SecondarySidebarLayout list={filteredList} title="">
        <Outlet />
      </SecondarySidebarLayout>
    ),
    children,
  }

};
